import React from "react";

import { StyledSVG } from "../StyledIcon";

export const DocIcon = props => {
  const { iconColor, iconWidth, iconHeight } = props;

  return (
    <StyledSVG
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      viewBox="0 0 18 18"
      fill="none"
      {...props}
    >
      <path
        d="M3 3.25C3 2.69772 3.44772 2.25 4 2.25H11.5858C11.851 2.25 12.1054 2.35536 12.2929 2.54289L14.7071 4.95711C14.8946 5.14464 15 5.399 15 5.66421V14.75C15 15.3023 14.5523 15.75 14 15.75H4C3.44772 15.75 3 15.3023 3 14.75V3.25Z"
        stroke={iconColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6 6H12"
        stroke={iconColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6 9H12"
        stroke={iconColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6 12H12"
        stroke={iconColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </StyledSVG>
  );
};
